import events from './events';

const bus = riot.observable();
bus.EVENTS = events;

export default bus;
